import { render } from "./NegociosContent.vue?vue&type=template&id=cc4504a6"
import script from "./NegociosContent.vue?vue&type=script&lang=js"
export * from "./NegociosContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__